import React, { useContext } from 'react';

import { hasFeature } from './feature-flags';

const featureContext = React.createContext(hasFeature);

export const useHasFeature = (label) => {
    const hasFeatureUse = useContext(featureContext);
    return hasFeatureUse(label);
};

export default useHasFeature;
